// Preserve legacy action bodies and dispatch order.
/* eslint-disable import/order, arrow-body-style, @typescript-eslint/no-unused-vars */
import type {
  SetPositionCategoryIdType,
  SetPositionProductType,
  SetPositionPageType,
  SetPositionPayloadType,
} from 'utils/apiList/setPosition'
import type { DispatchFnType } from 'storeContext/types'
import type {
  SetPositionActionType,
  SetPositionPaginationType,
} from 'storeContext/reducers/setPosition'
import { toastFailed, toastSuccess } from 'utils/toast'
import {
  SET_IS_SUCCESS_SETPOS_PRODUCT,
  SET_IS_PAGINATION_DATA_SETPOS_PRODUCT,
} from 'storeContext/actionsType/setPosition'
import { getProductPosition, postAddProductPosition } from 'utils/apiList/setPosition'
import { startSetPos, stopSetPos, getReloadData } from './index'

export const getSetPosProductData = (
  data: SetPositionPageType<SetPositionProductType>,
): SetPositionActionType => {
  return {
    type: SET_IS_SUCCESS_SETPOS_PRODUCT,
    payload: data,
  }
}

export const setPaginationSetPosProduction = (
  data: SetPositionPaginationType,
): SetPositionActionType => {
  return {
    type: SET_IS_PAGINATION_DATA_SETPOS_PRODUCT,
    payload: data,
  }
}

export const getListOfSetPositionProduct =
  (category_id: SetPositionCategoryIdType, query = '') =>
  (dispatch: DispatchFnType) => {
    dispatch(startSetPos())

    return getProductPosition(category_id, query)
      .then(({ data }) => {
        dispatch(stopSetPos())
        const pagination = {
          currentItem: data.numberOfElements,
          currentPage: data.number,
          pageSize: data.size,
          totalData: data.totalElements,
          totalPage: data.totalPages,
        }
        dispatch(setPaginationSetPosProduction(pagination))
        dispatch(getSetPosProductData(data))
        // console.log(data);
      })
      .catch(() => {
        dispatch(stopSetPos())
        toastFailed('terjadi masalah, coba beberapa saat lagi')
      })
  }

export const postPosition = (dataToSend: SetPositionPayloadType) => (dispatch: DispatchFnType) => {
  dispatch(startSetPos())

  return postAddProductPosition(dataToSend)
    .then(({ data: _data }) => {
      dispatch(stopSetPos())
      dispatch(getReloadData())

      toastSuccess('Berhasil merubah posisi produk')
      // console.log(data);
    })
    .catch(() => {
      dispatch(stopSetPos())
      toastFailed('terjadi masalah, coba beberapa saat lagi')
    })
}
